import { render, staticRenderFns } from "./ItemCardPrintingMeasurements.vue?vue&type=template&id=ade79fb4&scoped=true&"
import script from "./ItemCardPrintingMeasurements.vue?vue&type=script&lang=js&"
export * from "./ItemCardPrintingMeasurements.vue?vue&type=script&lang=js&"
import style0 from "./ItemCardPrintingMeasurements.vue?vue&type=style&index=0&id=ade79fb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade79fb4",
  null
  
)

export default component.exports